module.exports = __webpack_public_path__ + "img/r2.ecb5cfb1.png";